import { AlkLogger } from '@alk/core';
/**
 * This function receives a decoded chunk of data as a string.
 * A chunk can contain 1 or more events. It can also contain part of one single event.
 *
 * @returns
 * The function parses those chunks and returns them as an Array of string.
 *
 * @remarks
 * The string is the event value.
 * The function process incomplete values from previous events once we parse the next chunk
 *
 * @param value the chunk of decoded Uint8Array as string that contains some event data
 * @param incomplete message events from a previous chunk parse
 */
export function parseStringEvent(value, incomplete) {
    AlkLogger.debug('parseStringEvent value:', value);
    const hasIncompleteMessage = !value.endsWith('\n\n');
    const parts = value.split('\n\n');
    if (incomplete.message !== '') {
        parts[0] = `${incomplete.message}${parts[0]}`;
        incomplete.message = '';
    }
    if (hasIncompleteMessage) {
        incomplete.message = parts.pop();
    }
    return parts.map(message => message.replace(new RegExp('\\n', 'g'), ''));
}
